import { useEffect, useState, useRef } from 'react';
import { StyleSheet, View, Text, SafeAreaView, Dimensions, ActivityIndicator, Platform, ImageBackground } from 'react-native';
import { LinearGradient } from "expo-linear-gradient";
import RootNavigation from './routes';
import * as Font from 'expo-font';
import fonts from './src/theme/fonts';
import 'react-native-gesture-handler';
import * as Network from 'expo-network';
import HeaderCenter from './src/components/Header/headerCenter';

import {
  NavigationContainer
} from '@react-navigation/native';
import {
  createNativeStackNavigator 
} from '@react-navigation/native-stack';


import ErrorScreen from "./src/screens/configError";
import { api } from './src/api';
import images from './src/theme/images';

const Stack = createNativeStackNavigator ();

const App = () => {
  const [loaded, setLoaded] = useState(false);
  const [gotConfig, setConfig] = useState(false);
  const [noConfigLoaded, setNoConfigLoaded] = useState(false);
  const [config, updateConfig] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [enteredDomain, setDomain] = useState(false);
  const [showDefault, setDefaultShow] = useState(false);

  const getConfig = async () => {
    let data = null
    if(gotConfig == false){
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const domain = urlParams.get('domain');
        if(Platform.OS == "web"){
          if(domain == "default"){
            setDefaultShow(true);
            setLoaded(true);
          } else {
            try {
              const resp = await api(`v1/preview/?domain=${ enteredDomain ? enteredDomain : domain}`, "GET", null)
              console.log(resp.data);
              if(resp.status== 200){
                let result = resp.data;
                if(result.success){
                  data = result.response.config;
                  if(data != null){
                    updateConfig(data);
                    setNoConfigLoaded(false);
                  } else {
                    setNoConfigLoaded(true);
                  }
                }
                setConfig(true)
                setLoaded(true);
                return;
              }
              setNoConfigLoaded(true);
              setConfig(true)
              setLoaded(true);
             } catch (error) {
                setNoConfigLoaded(true);
                // console.log("error: ", error)
             }
             setConfig(true)
             setLoaded(true);
          }
          
        } else {
          setNoConfigLoaded(true);
          setConfig(true)
          setLoaded(true);
        }
      } catch(error){
        setErrorMessage("App could not load all settings, please try again.")
        setNoConfigLoaded(true);
        // console.log(error)
      }
    }
  }

  useEffect(() => {
    const loadFonts = async () => {
      await Font.loadAsync(fonts);
      // getPreviewAppStatus();
      if(Platform.OS == "web"){
        if(gotConfig == false){
          getConfig();
        }
      } else {
        setLoaded(true);
      }
    };
    loadFonts();
  });

  if(!loaded){
    return (
      <SafeAreaView style={[styles.mainContainer]}>
        <LinearGradient
          // Background Linear Gradient
          colors={['#5CD04F', '#00BB86']}
          style={styles.background}
        />
        <ActivityIndicator size={"large"} color={"#FFF"} />
      </SafeAreaView>
    );
  }
  
  if(showDefault){
    return (
      <ImageBackground 
        style={{flex: 1, height: "100%"}}
        source={images.defaultBackground} 
        resizeMode={"cover"}
      />
    );
  }

  return (
    <View style={styles.container}>
      {
        noConfigLoaded ? (
          <NavigationContainer >
            <Stack.Navigator
              screenOptions={{
                cardOverlayEnabled: true,
                gestureEnabled: false,
              }}>
              <Stack.Screen
                name={"Config Error"}
                component={ErrorScreen}
                initialParams={{
                  config: config,
                  setConfig: setConfig,
                  onPress: setDomain,
                  setLoaded:setLoaded,
                  message: errorMessage
                }}
                options={{
                  headerShown: true,
                  headerTitle: () => (
                    <HeaderCenter 
                      type={"offline"}
                      config={config}
                    />
                  ),
                  headerStyle: {
                    backgroundColor: "#00BB86",
                    color: "#FFF"
                  },
                }}
              />
            </Stack.Navigator>
          </NavigationContainer>
        ) : (
          <RootNavigation 
            config={config} 
            siteURL={config.siteURL}
          />
        )
      }
    </View>
  );
}
export default App;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  mainContainer: {
    flex: 1, 
    alignItems: 'center', 
    justifyContent: 'center', 
    width: Dimensions.get("screen").width,
  },
  background: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    height: Dimensions.get("screen").height,
  },
});